import "../stylesheets/EditEntryScreen.css";

import React from "react";
import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "@ckeditor/ckeditor5-build-classic/build/translations/de";
import Select from "react-select";
import Files from "react-files";
import MultiSelect from "react-multiselect-checkboxes";

import Util from "../classes/Util";
import ScreenManager from "../manager/ScreenManager";
import PageManager from "../manager/PageManager";
import BlobManager from "../manager/BlobManager";

import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import PageTemplate from "../classes/PageTemplate";
import { FaBan } from "react-icons/fa";

const screenManager = ScreenManager.instance;
const pageManager = PageManager.instance;
const blobManager = BlobManager.instance;

const MAX_FILE_SIZE = 25000000;
const MAX_FILE_AMOUNT = 25;

export default class AddEntryScreen extends React.PureComponent {

    /** @type {{ section: string, template: import("../classes/PageTemplate").default }} */
    props;

    constructor(props) {
        super(props);

        const allSectionParts = pageManager.getSectionsArray();
        const sectionParts = pageManager.getSectionPartsBySectionName( "reasons" );
        const tmpl = new PageTemplate("grievances", "", pageManager.getSectionsArray().map( s => [s.id, s.template] ));

        this.state = {
            anonymous: tmpl.submitter === undefined,
            allTags: new Map(
                pageManager.TAG_CATEGORIES.map( (tagCategory, index) => [
                    index,
                    pageManager.getTagsArray().filter( tag => tagCategory[1].includes(tag.id) ).map( tag => ({ value: tag.id, label: tag.name }) )
                ])
            ),
            //allAudiences: pageManager.getAudiencesArray().map( tag => ({ value: tag.id, label: tag.name }) ),
            currentTab: sectionParts[0].id,
            sections: sectionParts,
            /** @type {File[]} */
            files: [],
            uploading: false,
            loading: true
        }

        // contains the text of each section
        this.currentText = new Map( allSectionParts.map( part => [part.id, tmpl.text.get(part.id) || ""] ) );

        // selected tags of this page
        /** @type {Map<number, { value: number, label: string }[]>} */
        this.selectedTags = new Map(
            pageManager.TAG_CATEGORIES.map( (tagCategory, index) => [
                index,
                tmpl.tags.filter( tag => tagCategory[1].includes(tag.id) ).map( tag => ({ value: tag.id, label: tag.name }) )
            ])
        );

        /** @type {{ value: string, label: string }} */
        this.region = Util.REGIONS.find( region => region.value === tmpl.region ) || null;

        // selected audiences of this page
        /** @type {{ value: number, label: string }[]} */
        //this.selectedAudiences = tmpl.audiences.map( tag => ({ value: tag.id, label: tag.name }) );

    }

    async componentDidMount() {
        if (!await pageManager.refetchTopicInfo()) screenManager.showError("Die Kategorien konnten nicht vom Server geladen werden!");
        
        this.setState({
            allTags: new Map(
                pageManager.TAG_CATEGORIES.map( (tagCategory, index) => [
                    index,
                    pageManager.getTagsArray().filter( tag => tagCategory[1].includes(tag.id) ).map( tag => ({ value: tag.id, label: tag.name }) )
                ])
            ),
            loading: false
        });
    }

    render() {

        // show loading status
        if (this.state.loading) return (
            <div className="flexContainer secondaryColorBackground centeredItems">
                <div className="spinner-border" role="status" />
                <div className="spacerH-1em" />
                lade...
            </div>
        );

        // the page template class
        const tmpl = this.props.template || new PageTemplate("grievances", "", pageManager.getSectionsArray().map( s => [s.id, s.template] ));

        // render
        return (

            <div className="flexContainer secondaryColorBackground centeredHorizontal" id="addReasonScreenContainer">
                <Form onSubmit={e => this.onSubmit(e)} id="addReasonScreenForm" >

                    <Form.Group style={{ flexDirection: "row" }} >
                        <Form.Label>Titel</Form.Label>
                        <Form.Control placeholder="Kompakter Titel" name="addReasonScreenForm-title" defaultValue={tmpl.title} />
                    </Form.Group>

                    <Tabs
                        activeKey={this.state.currentTab}
                        onSelect={tab => this.changeTab( tab )}
                    >
                        { this.state.sections.map(section => <Tab key={"tab-"+section.id} eventKey={section.id} title={section.title} />) }
                    </Tabs>

                    <CKEditor
                        name="addReasonScreenForm-text"
                        id="addReasonScreenTextArea"
                        editor={ ClassicEditor }
                        className="markdown-body"
                        data={this.currentText.get(this.state.currentTab)}
                        config={{
                            removePlugins: ["CKFinderUploadAdapter", "CKFinder", "EasyImage", "Image", "ImageCaption", "ImageStyle", "ImageToolbar", "ImageUpload", "MediaEmbed"],
                            toolbar: [ "heading", "|", "bold", "italic", "link", "bulletedList", "numberedList","blockQuote", "insertTable", "undo", "redo" ],
                            language: "de",
                            heading: {
                                options: [
                                    { model: "heading1", view: "h4", title: "Hauptüberschrift", class: "ck-heading_heading4" },
                                    { model: "heading2", view: "h5", title: "Unterüberschrift", class: "ck-heading_heading5" }
                                ]
                            },
                            /*autoParagraph: false,
                            enterMode: CKEditor.CKEditor.ENTER_BR,
                            shiftEnterMode: CKEditor.CKEditor.ENTER_P*/
                        }}
                        onInit={editor => this.editor = editor }
                    />

                    <div className="spacerH-1em" />

                    <Form.Label>Kategorien</Form.Label>
                    <div id="addReasonScreenCategoryContainer" >
                        {
                            pageManager.TAG_CATEGORIES.map( (tagCategory, index) =>
                                <Form.Group key={"category:"+index} >
                                    <Form.Label>{tagCategory[0]}</Form.Label>
                                    <MultiSelect
                                        styles={{ dropdownButton: (provided) => ({ ...provided, width: "100%" }) }}
                                        placeholderButtonLabel="Kategorien angeben"
                                        options={this.state.allTags.get(index)}
                                        defaultValue={this.selectedTags.get(index)}
                                        onChange={selectedTags => this.selectedTags.set(index, selectedTags)}
                                    />
                                </Form.Group>
                            )
                        }
                    </div>

                    <div className="spacerH-1em" />

                    <Form.Group >
                        <Form.Label>Betroffenes Bundesland</Form.Label>
                        <Select
                            placeholder="Bundesland auswählen"
                            options={Util.REGIONS}
                            defaultValue={this.region}
                            onChange={region => this.region = region}
                        />
                    </Form.Group>

                    <div className="spacerH-1em" />

                    <Form.Label>Dateien</Form.Label>
                    <Files
                        multiple
                        maxFiles={MAX_FILE_AMOUNT}
                        maxFileSize={MAX_FILE_SIZE}
                        minFileSize={0}
                        clickable={false}
                        onChange={this.onFileAdded.bind(this)}
                        onError={this.onFileError.bind(this)}
                    >
                        <div id="addReasonScreenCategoryContainer" className="addReasonScreenAddFileText" >
                            Dateien hier hereinziehen...
                            <div className="spacerH-1em" />
                            {
                                this.state.files.map( (file, index) => 
                                    <div key={`file-${index}`} id="addReasonScreenFileContainer" > {`${file.name} (${file.sizeReadable})`} <FaBan onClick={ () => this.onFileDelete(index) } color="red" /> </div>
                                )
                            }
                        </div>
                    </Files>

                    <div className="spacerH-1em" />

                    <Form.Check
                        type="checkbox"
                        label="anonym"
                        name="anonymus"
                        checked={this.state.anonymous}
                        onChange={() => this.setState( prevState => ({ anonymus: !prevState.anonymus }) )}
                    />

                    <Form.Row>
                        <Form.Group as={Col} >
                            <Form.Label>Vorname</Form.Label>
                            <Form.Control placeholder="Franz" name="addReasonScreenForm-firstName" maxLength={50} disabled={this.state.anonymous} defaultValue={tmpl.submitter && tmpl.submitter.firstName} />
                        </Form.Group>

                        <Form.Group as={Col} >
                            <Form.Label>Nachname</Form.Label>
                            <Form.Control placeholder="Müller" name="addReasonScreenForm-lastName" maxLength={50} disabled={this.state.anonymous} defaultValue={tmpl.submitter && tmpl.submitter.lastName} />
                        </Form.Group>
                    </Form.Row>

                    <Form.Row>
                        <Form.Group as={Col} >
                            <Form.Label>Straße</Form.Label>
                            <Form.Control placeholder="Schlossallee 7" name="addReasonScreenForm-street" maxLength={50} disabled={this.state.anonymous} defaultValue={tmpl.submitter && tmpl.submitter.street} />
                        </Form.Group>

                        <Form.Group as={Col} >
                            <Form.Label>PLZ</Form.Label>
                            <Form.Control placeholder="12249" name="addReasonScreenForm-zip" maxLength={5} disabled={this.state.anonymous} defaultValue={tmpl.submitter && tmpl.submitter.zip} />
                        </Form.Group>

                        <Form.Group as={Col} >
                            <Form.Label>Stadt</Form.Label>
                            <Form.Control placeholder="Berlin" name="addReasonScreenForm-city" maxLength={50} disabled={this.state.anonymous} defaultValue={tmpl.submitter && tmpl.submitter.city} />
                        </Form.Group>
                    </Form.Row>

                    <div className="spacerH-1em" />

                    <Button type="submit" disabled={this.state.uploading} block >{this.state.uploading ? "lade hoch..." : "Senden"}</Button>
                </Form>

                {this.props.children}
            </div>

        );

    }

    /** @param {string} tab */
    changeTab( tab ) {
        // save the current editor for this section
        this.currentText.set(this.state.currentTab, this.editor.getData());

        // set editor text of new section
        this.editor.setData( this.currentText.get(tab) );

        // change tab
        this.setState({ currentTab: tab });
    }

    /**
     * @param {React.FormEvent} event The form event called when it was submitted
     */
    async onSubmit( event ) {
        event.preventDefault();

        // save current section text
        this.currentText.set(this.state.currentTab, this.editor.getData());

        this.setState({ uploading: true });

        const data = {
            title: "",
            firstName: "",
            lastName: "",
            street: "",
            zip: "",
            city: ""
        };

        const entry = {};
        Object.keys(data).forEach( name => data[name] = event.target["addReasonScreenForm-"+name] && event.target["addReasonScreenForm-"+name].value.trim() );

        entry.title = data.title.replace(/\s\s/g, "");
        entry.text = Array.from( this.currentText.entries() );
        entry.tagIds = Array.from(this.selectedTags.values()).reduce( (prev, cur) => prev.concat(cur), [] ).map( selectedTag => selectedTag.value );
        //entry.audienceIds = this.selectedAudiences.map( t => t.value );
        entry.audienceIds = [];
        entry.region = this.region != null ? this.region.value : null;

        if (!this.state.anonymous) {
            entry.submitter = {};
            entry.submitter.firstName = data.firstName.replace(/\s\s/g, "");
            entry.submitter.lastName = data.lastName.replace(/\s\s/g, "");
            entry.submitter.street = data.street.replace(/\s\s/g, "");
            entry.submitter.city = data.city.replace(/\s\s/g, "");
            entry.submitter.zip = data.zip.replace(/\D/g, "");
        }

        try {
            if (entry.tagIds.length === 0) throw new Error("Dem Eintrag muss mindestens eine Kategorie zugewiesen werden.");
            if (entry.title.length < 3) throw new Error("Bitte geben Sie einen Titel an.");
            if (entry.region == null) throw new Error("Bitte wählen Sie ein Bundesland aus.");

            // the files to upload
            const { files } = this.state;
            if (files.length > 0) {

                // get one time upload URLs
                try {
                    var uploadUrls = await blobManager.getUploadUrls( files.length );
                } catch(e) {
                    console.error(e);
                    throw new Error(`Die Anfrage zum Hochladen der Dateien konnte nicht ausgeführt werden!`);
                }
    
                // upload files in parallel
                const blobFilenames = await Promise.all( files.map( async (f, i) => {
                    try {

                        const uploadUrl = uploadUrls[i];
                        const blobFilename = uploadUrl.split("/").slice(-1)[0].split("?")[0];
                        console.log(`Uploading file "${f.name}" into blob "${blobFilename}"...`);

                        // upload
                        await blobManager.createBlob(
                            blobManager.getAnonymousBlobUrl(uploadUrl),
                            f,
                            "application/octet-stream",
                            {},
                            `attachment; filename="${f.name}"`
                        );

                        // return blob filename to store in the post
                        return blobFilename;

                    } catch(e) {
                        console.error(e);
                        throw new Error(`Die Datei "${f.name}" konnte nicht hochgeladen werden. Bitte versuchen Sie es erneut.`);
                    }
                }));

                // add blob filenames to forum entry
                entry.files = blobFilenames;
            }

            await pageManager.uploadPage( entry );
            screenManager.changeScreen( "ThanksForSubmit", { anonymous: this.state.anonymous, title: entry.title, files: entry.files && entry.files.length !== 0 } );
        } catch(e) {
            this.setState({ uploading: false });
            screenManager.showError(e instanceof Error ? "Der Eintrag konnte nicht übertragen werden. Grund: " + e.message : "Der Eintrag konnte nicht an den Server übermittelt werden!");
        }

    }

    /**
     *
     * @param {File[]} files
     */
    onFileAdded( files ){
        this.setState({ files });
    }

    /**
     *
     * @param {Error & { code: number }} error
     * @param {File & { sizeReadable: string }} file
     */
    onFileError( error, file ){

        switch (error.code) {
            case 2:
                screenManager.showError(`Datei zu groß (${file.sizeReadable}), erlaubt sind maximal ${(MAX_FILE_SIZE/1000000).toFixed(1)}MB`);
                break;
            case 4:
                screenManager.showError(`Maximale Dateien Anzahl erreicht (${file.maxLength}), erlaubte Anzahl: ${MAX_FILE_AMOUNT}`);
                break;
            default:
                screenManager.showError(`Die Datei konnte nicht hinzugefügt werden!`);
        }
    }

    onFileDelete( index ) {
        this.state.files.splice(index, 1);
        this.setState({ files: [...this.state.files] })
    }
}